export default __webpack_public_path__ + "static/media/end.1d9607bb.mp3";